module.exports = __webpack_public_path__ + "static/media/play__OLD.0265965b.svg";